import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
	Header,
	Title,
	Subtitle,
	Button,
	Input,
	InputWrapper,
	GroupInput,
	Form,
	HiddenWrapper,
} from './signupFormStyles';

import Spinner from 'core/components/Spinner';
import { AmpCheck } from 'core/providers/AmpProvider';

class SignupForm extends Component {
	render () {
		const {
			formHandler,
			email,
			inputChangeHandler,
			inputBlurHandler,
			inputFocusHandler,
			emailInvalid,
			loading,
			submitText,
			title,
			subtitle,
			redirectUrl,
		} = this.props;
		const invalidInputs = emailInvalid;
		const disabled = invalidInputs || loading;

		return (
			<AmpCheck>{({ amp }) => (
				<Form action="/handle-subscribe/" noValidate={!amp} onSubmit={formHandler} target="_top">
					<Header>
						<Title>{ title }</Title>
						<Subtitle>{ subtitle }</Subtitle>
					</Header>
					<GroupInput>
						<InputWrapper>
							<Input
								id="signupWidgetEmail"
								placeholder="Email Address"
								type="email"
								name="email"
								value={email}
								onChange={inputChangeHandler}
								onFocus={inputFocusHandler}
								onBlur={inputBlurHandler}
								required
								focusColor={'lavender'}
								errorMsg={emailInvalid ? 'Invalid email' : undefined}
							/>
						</InputWrapper>
						{amp && (<HiddenWrapper>
							<Input placeholder="Back Url" type="hidden" value={redirectUrl} name="redirect_url" id="signupWidgetHiddenRedirectUrl" />
						</HiddenWrapper>)}
						<Button type="submit" disabled={disabled}>
							{ loading ? <Spinner /> : submitText }
						</Button>
					</GroupInput>
				</Form>
			)}</AmpCheck>
		);
	}

	static propTypes = {
		title: PropTypes.string,
		subtitle: PropTypes.string,
		submitText: PropTypes.string,
		email: PropTypes.string,
		emailInvalid: PropTypes.bool,
		inputChangeHandler: PropTypes.func,
		inputBlurHandler: PropTypes.func,
		inputFocusHandler: PropTypes.func,
		formHandler: PropTypes.func,
		loading: PropTypes.bool,
		redirectUrl: PropTypes.string,
	}
}

export default SignupForm ;
